import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import Constants from "../../Action/Constants";
import Logger from "../../Logger/Logger";
import Store from "../../Store/Store";
import Environment from "../../Environment/Environment";

class LogConnect extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(): void {
    if (Environment.isDevelopment() === true) {
      Logger.log("Socket connected");
    }

    Store.getConfigurator().dispatch({
      type: Constants.SOCKET_CONNECTED
    });
  }

}

export { LogConnect };
